import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroPedagogicoDetalhes(id): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>(`/termometro/pedagogico/detalhes_aluno/?student_id=${id}`, {});
  return data;
}

type QueryFnType = typeof getTermometroPedagogicoDetalhes;

function useTermometroPedagogicoDetalhes(id) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-pedagogico-detalhes', id],
    queryFn: () => getTermometroPedagogicoDetalhes(id),
  });
}

export { getTermometroPedagogicoDetalhes, useTermometroPedagogicoDetalhes };
